import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { LinearProgress } from "@mui/material";
import colors from "../../../../scss/colors";

export default function BuildingProgress() {
    const texts = [
        "Building Your Profile",
        "Extracting CV",
        "Preparing Your Profile",
        "Finalizing Details",
        "Optimizing your Profile",
        "Almost done..."
    ];

    const [text, setText] = useState("");
    const [index, setIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [deleting, setDeleting] = useState(false);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (done) return;

        const current = texts[index];
        let typingSpeed = deleting ? 50 : 120;

        const timeout = setTimeout(() => {
            if (!deleting && charIndex < current.length) {
                setText(current.substring(0, charIndex + 1));
                setCharIndex((prev) => prev + 1);
            } else if (!deleting && charIndex === current.length) {
                // pause at full phrase
                if (index === texts.length - 1) {
                    // last phrase → stop
                    setDone(true);
                } else {
                    setTimeout(() => setDeleting(true), 1000);
                }
            } else if (deleting && charIndex > 0) {
                setText(current.substring(0, charIndex - 1));
                setCharIndex((prev) => prev - 1);
            } else if (deleting && charIndex === 0) {
                setDeleting(false);
                setIndex((prev) => prev + 1);
            }
        }, typingSpeed);

        return () => clearTimeout(timeout);
    }, [charIndex, deleting, index, done, texts]);

    return (
        <>
        <LinearProgress
            variant="indeterminate"
            color="inherit"
            sx={{
                m: 1,
                width: "100%",
                position: "absolute",
                top: "57px",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: colors.LIGHTER_BLUE,
                "& .MuiLinearProgress-bar": {
                    backgroundColor: colors.LIGHT_BLUE,
                },
            }}
        />
        <Box
            sx={{
                m: 1,
                position: "absolute",
                top: "120px",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
            }}
        >
            <div className="flex justify-center items-center text-navy-blue font-medium text-xl relative z-10 animate-pulse w-full">
                {text}
            </div>
        </Box>
        </>
    );
}